import axios from 'axios';

import { get, remove } from './api';
import { GetAttachmentUrlResponseDTO } from 'declarations/dto/attachments';

export const getAttachmentApi = async (ticketId: string, fileName: string) => {
  const response = await get<string>(`/attachment/${ticketId}/${fileName}`, undefined, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] };
};

export const getViewAttachmentApi = async (ticketId: string, fileName: string) => {
  const response = await get<string>(`/attachment/view/${ticketId}/${fileName}`, undefined, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] };
};

export const deleteAttachmentApi = async (
  ticketId: string,
  fileName: string,
  originalName: string
) => {
  const response = await remove<void>(`/attachment/${ticketId}/${fileName}`, {
    params: { OriginalName: originalName },
  });

  return response.data;
};

export const getAttachmentUrlApi = async (ticketId: string, fileName: string) => {
  const response = await get<GetAttachmentUrlResponseDTO>(
    `/attachment/url/${ticketId}/${fileName}`
  );

  return response.data;
};

export const getAttachmentFromSignedUrlApi = async (ticketId: string, fileName: string) => {
  var signedUrl = await getAttachmentUrlApi(ticketId, fileName);

  // Need to use axios without any authorization
  const axiosWithoutAuth = axios.create({
    baseURL: signedUrl.value,
  });

  const response = await axiosWithoutAuth.get<string>(signedUrl.value, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] };
};
